import { Menu, Portal, Separator } from '@chakra-ui/react';
import React from 'react';

export function CardMenu({
  value,
  children,
  data,
  onClick,
  placement = 'top-start',
  itemProps,
  container,
}: {
  value?: string;
  children: React.ReactNode;
  data: any;
  placement?: any;
  onClick?: (value: string) => void;
  itemProps?: any;
  container?: React.RefObject<HTMLDivElement | null>;
}) {
  return (
    <Menu.Root positioning={{ placement }}>
      <Menu.Trigger cursor="pointer">{children}</Menu.Trigger>
      <Portal container={container}>
        <Menu.Positioner>
          <Menu.Content
            backdropFilter="blur(5px)"
            rounded="lg"
            bg="blackAlpha.50"
            minW="178px"
            p="2"
          >
            <Menu.RadioItemGroup value={value} onValueChange={(e) => onClick?.(e.value)}>
              {data.map((v: any, index: number) => {
                if (v.type === 'divider') {
                  return (
                    <Separator
                      key={`separator-${index}`}
                      orientation="horizontal"
                      borderColor="whiteAlpha.10"
                      my="1"
                    />
                  );
                }

                return (
                  <Menu.RadioItem
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    value={v.key}
                    key={v.key}
                    cursor="pointer"
                    color="white"
                    fontSize="sm"
                    py="3"
                    {...itemProps}
                  >
                    {v.label}
                    <Menu.ItemIndicator />
                  </Menu.RadioItem>
                );
              })}
            </Menu.RadioItemGroup>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
}

export default CardMenu;
